export class WInvalidEvent extends Event {
    constructor() {
        super('w-invalid', { bubbles: true, cancelable: false, composed: true });
    }
}
//# sourceMappingURL=invalid.js.map